import Card from "@/components/Card";

const LatestUpdates = () => {
  return <Card title={"Latest updates"}>Latest updates</Card>;
};

export default LatestUpdates;
